<template>
  <q-page style="height: 100vh" class="col-12 flex content-center justify-center">
    <q-card class="q-ma-xl">
      <div class="row">
        <div class="col-0 col-sm-5 bg-primary rounded-left-borders xs-hide">
          <div class="row full-width full-height flex flex-justify-center q-pa-lg">
            <img alt="logo" src="../assets/logo.svg" class="full-width" />
          </div>
        </div>
        <div class="col-12 col-sm-7">
          <div class="row q-pa-sm-sm q-pa-md">
            <div class="col-12">
              <q-form @reset="onReset" @submit="onSubmit">
                <q-card-section>
                  <q-item>
                    <q-item-section class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <q-input
                        v-model="name"
                        :rules="[(val) => (val && val.length > 0) || $t('errTypeSomething')]"
                        filled
                        :placeholder="$t('yourName')"
                        lazy-rules
                        dense
                      />
                    </q-item-section>
                  </q-item>
                  <q-item>
                    <q-item-section class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <q-input
                        v-model="password"
                        :rules="[(val) => (val !== null && val !== '') || $t('errTypePasswd')]"
                        filled
                        :placeholder="$t('yourPasswd')"
                        lazy-rules
                        :type="isPwd ? 'password' : 'text'"
                        dense
                      >
                        <template v-slot:append>
                          <q-icon
                            :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                            mdi
                            class="cursor-pointer"
                            @click="isPwd = !isPwd"
                          />
                        </template>
                      </q-input>
                    </q-item-section>
                  </q-item>
                  <q-card-actions align="left" class="q-pl-lg">
                    <q-btn color="primary" :label="$t('submit')" type="submit" />
                    <q-btn class="q-ml-sm" flat :label="$t('reset')" type="reset" />
                  </q-card-actions>
                </q-card-section>
              </q-form>
            </div>
          </div>
        </div>
      </div>
    </q-card>
  </q-page>
</template>

<script lang="ts" setup>
import { useQuasar } from 'quasar';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Router } from '@/router';
import { type LoginResponse } from '@/types/auth';
import { useAuthStore } from '@/stores/auth';

const $q = useQuasar();
const { t } = useI18n();

const name = ref(null);
const isPwd = ref(true);
const password = ref(null);

async function onSubmit() {
  const authStore = useAuthStore();
  return authStore
    .login(name.value ?? '', password.value ?? '')
    .then(async (response: LoginResponse) => {
        if (response.sessionId ?? false) {
          await authStore.verifyTFA(response);
        }
        if (authStore.refresh != null && authStore.access != null) {
          $q.notify({
            color: 'green-4',
            icon: 'mdi-check-circle',
            message: t('successful.logged.in')
          });
          return Router.push({ name: 'home' });
        }
        return Promise.reject(Error('login failed'));
      }
    ).catch(error);
}

function onReset() {
  name.value = null;
  password.value = null;
}

function error(error: Error) {
  $q.notify({
    color: 'red-4',
    icon: 'mdi-alert-circle',
    message: t(error.toString())
  });
}
</script>
